import React, { Component } from 'react';
import { connect } from 'react-redux';

import Aux from '../../../../hoc/_Aux';
import * as actionTypes from '../../../../store/actions';
import appLogo from '../../../../assets/images/vie-logo.png'

class NavBar extends Component {
  render() {
    let headerClass = ['navbar', 'pcoded-header', 'navbar-expand-lg', this.props.headerBackColor];
    if (this.props.headerFixedLayout) {
      headerClass = [...headerClass, 'headerpos-fixed'];
    }

    let toggleClass = ['mobile-menu'];
    if (this.props.collapseMenu) {
      toggleClass = [...toggleClass, 'on'];
    }

    return (
      <Aux>
        <header className={headerClass.join(' ')}>
          <div className="m-header">
            <a className={toggleClass.join(' ')} id="mobile-collapse1" onClick={this.props.onToggleNavigation}>
              <span />
            </a>
            <a className="b-brand">
              <div>
                <img className="mobile-menu-logo" src={appLogo} alt="Generic placeholder" />
              </div>
            </a>
          </div>
        </header>
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    rtlLayout: state.rtlLayout,
    headerBackColor: state.headerBackColor,
    headerFixedLayout: state.headerFixedLayout,
    collapseMenu: state.collapseMenu,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onToggleNavigation: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavBar);
